import {
  ActionIcon,
  Anchor,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Select,
  Switch,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconExternalLink,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { getArticleCategory, syncArticleSearch } from "../../../api/ApiArticle";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
import UpdateOrderNumberView from "./updateorderNumberView";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import AppAction from "../../../common/AppAction";
import { BASE_API_URL } from "../../../config";
import ModalUpdateExcelProduct from "../../ProductManager/ProductList/ModalUpdate/ModalUpdateExcelProduct";
interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
}

const ArticleCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [dataArticleCategory, setDataArticleCategory] = useState<any[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const optionSearch = {
    isActive: [
      {
        value: "2",
        label: "Bản nháp",
        "data-test-subj": "titanOption",
      },
      {
        value: "1",
        label: "Đã duyệt",
        "data-test-subj": "titanOption",
      },
      {
        value: "0",
        label: "Chờ duyệt",
      },
    ],
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
      location: _searchJson && checkedPinSearch ? _searchJson?.location : "",
    },
  });
  const getStatusColor = (status: any) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "green";
      case 2:
        return "subdued";
      case "Y":
        return "#f9fd04";
      case "N":
        return "gray";
      default:
        return "subdued";
    }
  };
  const styleTableMantine = {
    fontWeight: "500",
  };
  const updateLocalData = (
    id: number,
    field: "active" | "priority",
    value: string
  ) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  // Hàm xử lý chỉnh sửa bài viết
  const editArticle = (
    id: number,
    type: string,
    title: string,
    openInNewTab: boolean = false
  ) => {
    // Kiểm tra localStorage trước
    let tabParam = null;
    try {
      const storedData = localStorage.getItem("hacom_edit_article");
      if (storedData) {
        const articleData = JSON.parse(storedData);
        if (articleData.tab && articleData.id === id) {
          tabParam = articleData.tab;
        }
      }
    } catch (error) {
      console.error("Error reading tab from localStorage:", error);
    }

    // Nếu không có trong localStorage, thử lấy từ URL
    if (!tabParam) {
      const queryParams = new URLSearchParams(location.search);
      tabParam = queryParams.get("tab");
    }

    const article = data.find((item) => item.id === id);
    const articleTitle = article ? article.title : title;

    navigate(`/article-manager/edit-article/${id}`, {
      state: {
        type: type,
        title: articleTitle ? articleTitle : "",
        initialTab: tabParam ? tabParam : undefined,
      },
    });
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "thumnail",
        header: "Ảnh ",
        size: 135,
        Cell: ({ row }) => {
          const url = row.original.thumnail;
          if (!url) return null;
          return (
            <img
              src={url}
              alt={row.original.title}
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "title",
        header: "Tiêu đề",
        size: 300,
      },

      {
        accessorKey: "link",
        header: "Đường dẫn",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 135,
        Cell: ({ row }) => (
          <Group>
            <a
              href={`${hacomUrl}/tin-tuc/${row.original.url}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1c7ed6", textDecoration: "underline" }}
            >
              Xem trang bài viết
            </a>
          </Group>
        ),
      },
      {
        accessorKey: "summary",
        header: "Nội dung",
        size: 250,
        Cell: ({ row }) => <Text>{row.original.summary}</Text>,
      },
      {
        accessorKey: "ordering",
        header: "Thứ tự",
        size: 120,
        Cell: ({ row }) => {
          return (
            <Anchor
              fw={500}
              c="blue"
              ml={10}
              underline="hover"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const id = row.original.id;
                const orderNumber = row.original.ordering;
                console.log("data test", data);
                modals.openConfirmModal({
                  title: (
                    <>
                      <div color="white">
                        <Title order={5}>Cập nhật STT !</Title>
                      </div>
                    </>
                  ),
                  children: (
                    <UpdateOrderNumberView
                      onSearch={() => fetchData()}
                      id={id}
                      orderNumber={orderNumber ?? 0}
                      data={row.original}
                    />
                  ),
                  confirmProps: { display: "none" },
                  cancelProps: { display: "none" },
                });
              }}
            >
              {row.original.ordering}
            </Anchor>
          );
        },
      },
      {
        accessorKey: "postedDate",
        header: "Ngày đăng tải",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "createdBy",
        header: "Người viết",
      },
      {
        accessorKey: "visit",
        header: "Lượt xem",
        size: 135,
        Cell: ({ row }) => (
          <Text fw={500} c="#FF0000" ml={10}>
            {row.original.visit}
          </Text>
        ),
      },
      {
        accessorKey: "likeCount",
        header: "Lượt thích",
        size: 135,
      },
      {
        accessorKey: "commentCount",
        header: "Lượt bình luận",
        size: 135,
      },
      {
        accessorKey: "reviewCount",
        header: "Lượt đánh giá",
        size: 135,
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 135,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.status === 1}
              color="blue"
              size="xs"
              mr={3}
              onClick={async (e: any) => {
                open();
                await featuredActive(row.original.id, "status");
              }}
            />
            <Text>
              {" "}
              {row.original.status === 1
                ? "Hoạt động"
                : row.original.status === 2
                ? "Bản nháp"
                : "Chờ duyệt"}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "isStricking",
        header: "Nổi bật",
        size: 135,
        Cell: ({ row }) => (
          <>
            <Switch
              checked={row.original.isStricking === "Y"}
              color="blue"
              size="xs"
              mr={3}
              onClick={async (e: any) => {
                open();
                await featuredActive(row.original.id, "priority");
              }}
            />
            <Text>
              {" "}
              {row.original.isStricking === "Y" ? "Tắt nổi bật" : "Mở nổi bật"}
            </Text>
          </>
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdatedBy",
        header: "Người cập nhật",
      },
      {
        accessorKey: "action",
        header: "Thao tác ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="yellow"
                onClick={(e) => {
                  // Kiểm tra nếu nhấn Ctrl+Click hoặc Middle Click để mở tab mới
                  if (e.ctrlKey || e.button === 1) {
                    // Lưu thông tin vào localStorage để tab mới có thể sử dụng
                    const articleData = {
                      id: row.original.id,
                      type: "edit",
                      title: row.original.title,
                      timestamp: new Date().getTime(),
                    };
                    localStorage.setItem(
                      "hacom_edit_article",
                      JSON.stringify(articleData)
                    );

                    // Mở tab mới
                    const baseUrl =
                      window.location.origin + window.location.pathname;
                    window.open(baseUrl, "_blank");
                  } else {
                    // Chỉnh sửa bình thường
                    editArticle(
                      row.original.id,
                      "edit",
                      row.original.title,
                      false
                    );
                  }
                }}
                onMouseDown={(e) => {
                  // Xử lý middle click
                  if (e.button === 1) {
                    e.preventDefault();
                    const articleData = {
                      id: row.original.id,
                      type: "edit",
                      title: row.original.title,
                      timestamp: new Date().getTime(),
                    };
                    localStorage.setItem(
                      "hacom_edit_article",
                      JSON.stringify(articleData)
                    );
                    const baseUrl =
                      window.location.origin + window.location.pathname;
                    window.open(baseUrl, "_blank");
                  }
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={async () => {
                  await deleteItem([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Mở trang tab">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={(e: any) => {
                  // Lưu thông tin vào localStorage để tab mới có thể sử dụng
                  const articleData = {
                    id: row.original.id,
                    type: "edit",
                    title: row.original.title,
                    timestamp: new Date().getTime(),
                  };
                  localStorage.setItem(
                    "hacom_edit_article",
                    JSON.stringify(articleData)
                  );

                  // Mở tab mới
                  window.open("/article-manager/article-list", "_blank");
                }}
              >
                <IconExternalLink size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();

      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.status) {
        queryParams.append("Status", search.status);
      }
      if (search && search.location) {
        queryParams.append("ArticleCategoryId", search.location);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${
        API_ROUTE.GET_LIST_ARTICLE_LIST
      }?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...form.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };

  const loadArticleCategory = async () => {
    setDataArticleCategory([]);
    const data = await getArticleCategory("Skip=0&Take=1000");
    const transformedData = data?.data.map((item: any, index: number) => ({
      value: item.id.toString(),
      label: item.name,
    }));
    setDataArticleCategory(transformedData);
  };

  const featuredActive = async (id: number, type: string, order?: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      setIsLoading(true);
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      try {
        let urlSearch =
          type === "status"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_STATUS + id
            : type === "priority"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_STICKING + id
            : type === "order"
            ? API_ROUTE.MODIFY_ARTICLE_LIST_ORDER + id + "&order=" + order
            : "";
        let callapi = await repository.post<MessageResponse<boolean>>(
          urlSearch
        );
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSyncArticleSearch = async () => {
    open();
    try {
      const res = await syncArticleSearch();

      if (res && res.success) {
        close();
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const modalChangeOrderArticle = (id: number, orderNumber: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Cập nhật STT !</Title>
          </div>
        </>
      ),
      children: (
        <UpdateOrderNumberView
          onSearch={() => fetchData()}
          id={id}
          orderNumber={orderNumber ?? 0}
          data={data}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bài viết</Title>
        </>
      ),
      children: <DeleteView onSearch={() => fetchData()} idItem={idItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  const exportExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      const params = new URLSearchParams();

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { keySearch } = form.getValues();
      if (keySearch) params.append("KeySearch", keySearch);

      // Xây dựng URL API cuối cùng
      const queryString = params.toString();
      const baseUrl = `/ExportExcel/export-article${
        queryString ? `?${queryString}` : ""
      }`;

      const _url = BASE_API_URL + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "danh-sach-bai-viet.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };
  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Tạo danh mục sản phẩm bằng Excel</Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      showGlobalFilter: true,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["status", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    // mantineTableBodyCellProps: ({ row }) => ({
    //   style: styleTableMantine,
    // }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  // Xử lý khi URL có tham số để mở modal editArticle
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const openEdit = queryParams.get("openEdit");
    const idParam = queryParams.get("id");
    const tabParam = queryParams.get("tab");
    const titleParam = queryParams.get("title");
    const typeParam = queryParams.get("type") || "edit";

    if (openEdit === "true" && idParam) {
      // Mở modal chỉnh sửa bài viết với tham số từ URL (fullScreen = true cho tab mới)
      editArticle(parseInt(idParam), typeParam, titleParam || "", true);

      // Clear URL params after handling, but add a small delay
      setTimeout(() => {
        navigate("/article-manager/article-list", { replace: true });
      }, 500); // Give time for the modal to open
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const directQueryParams = new URLSearchParams(window.location.search);
    const directOpenEdit = directQueryParams.get("openEdit");
    const directIdParam = directQueryParams.get("id");
    const directTabParam = directQueryParams.get("tab");
    const directTitleParam = directQueryParams.get("title");
    const directTypeParam = directQueryParams.get("type") || "edit";

    if (directOpenEdit === "true" && directIdParam) {
      setTimeout(() => {
        editArticle(
          parseInt(directIdParam),
          directTypeParam,
          directTitleParam || "",
          true // fullScreen = true cho direct URL access
        );

        // Clean URL but keep the page path
        if (window.history && window.history.replaceState) {
          const cleanUrl = window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }, 300);
    }
  }, []); // Empty dependency array - runs only once on mount

  useEffect(() => {
    try {
      // Retrieve data from localStorage
      const storedData = localStorage.getItem("hacom_edit_article");
      if (storedData) {
        const articleData = JSON.parse(storedData);
        const currentTime = new Date().getTime();
        const dataTime = articleData.timestamp || 0;

        if (currentTime - dataTime < 300000) {
          if (articleData.id) {
            editArticle(
              parseInt(articleData.id),
              articleData.type || "edit",
              articleData.title || "",
              true // fullScreen = true cho localStorage (từ tab mới)
            );
            localStorage.removeItem("hacom_edit_article");
          }
        } else {
          localStorage.removeItem("hacom_edit_article");
        }
      }
    } catch (error) {
      console.error("Error processing localStorage data:", error);
      localStorage.removeItem("hacom_edit_article");
    }
  }, []);

  useEffect(() => {
    if (_searchJson) {
      setPagination({
        pageIndex: _searchJson.pageIndex,
        pageSize: _searchJson.pageSize,
      });
    }
  }, []);

  // useEffect để lắng nghe state từ navigation và reload data khi cần
  useEffect(() => {
    if (location.state?.shouldReload) {
      // Reload data khi có thông báo từ EditView
      setTimeout(() => {
        fetchData();
      }, 100);
      // Clear state để tránh reload không cần thiết
      navigate(location.pathname, {
        replace: true,
        state: undefined,
      });
    }
  }, [location.state]);

  useEffect(() => {
    fetchData();
    loadArticleCategory();
  }, [pagination]);
  return (
    <Box>
      <LoadingOverlayCustom visible={visible} />
      <Group gap={0} justify="space-between" mb={10}>
        <BreadCrumb></BreadCrumb>
        <Group>
          <Button
            mt={10}
            leftSection={<IconRefresh size={14} />}
            onClick={() => handleSyncArticleSearch()}
          >
            Đồng bộ tìm kiếm bài viết
          </Button>
          <Button
            mt={10}
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={() => {
              navigate("/article-manager/create-article");
            }}
          >
            Thêm mới
          </Button>
          <Button
            mt={10}
            mr={10}
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={async () => {
              const selectedIds = Object.keys(rowSelection).map(
                (key) => data[Number(key)].id
              );
              if (selectedIds && selectedIds.length < 1) {
                NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                return null;
              }
              await deleteItem(selectedIds);
            }}
          >
            Xóa (Đã chọn)
          </Button>
          <AppAction
            // openModal={openModal}
            // openModalDelete={openModalDelete}
            // openModalEdit={openModalEdit}
            isUpdateSearchItem={true}
            openModalupdateExel={openModalupdateExel}
            openExportExcel={exportExcel}
          ></AppAction>
        </Group>
      </Group>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật, có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid mt={10}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Trạng thái"
                data={optionSearch.isActive}
                key={form.key("status")}
                clearable
                {...form.getInputProps("status")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              />
              <Select
                placeholder="Loại bài viết"
                data={dataArticleCategory}
                key={form.key("location")}
                clearable
                searchable
                {...form.getInputProps("location")}
                classNames={{
                  dropdown: "custom-multiselect-dropdown",
                }}
                maxDropdownHeight={500}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default ArticleCategory;
